<template lang="pug">
v-app
  v-layout
    .payment-order-change-region-layout
      .payment-order-header
        v-btn( icon @click="$router.go(-1)" )
          v-icon( color="black" large ) mdi-close
      .payment-order-container
        .payment-order-title.pb-5 Управление Судебного департамента
        .title.pb-50 Выберите регион из списка для внесения средств на депозитный счет
        div( v-for="region in regions" )
          .title.region-text(@click="openRegionPage(region.alias)") {{ region.title }}
        div( v-if="!regions.length" )
          .title Список пуст
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('expert', ['regions']),
  },

  methods: {
    ...mapActions('expert', ['fetchRegions']),

    openRegionPage(alias) {
      this.$router.push({path: '/payment_order', query: { region: alias } })
    }
  },

  mounted() {
    this.fetchRegions()
  }
}
</script>

<style scoped>
.payment-order-change-region-layout {
  background-color: white;
  height: 100%;
  width: 100%;
}

.payment-order-header {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 30px 50px;
}

.payment-order-container {
  color: #424242;
  padding: 100px; 
}

.payment-order-title {
  font-weight: 600;
  font-size: 40px;
}

.region-text {
  color: #03A9F4;
  cursor: pointer;
}

.pb-50 {
  padding-bottom: 50px;
}

</style>